import React from 'react';
import { useTranslate } from 'ts/common/hooks';
import { useClientBookingExperience } from 'client_react/booking/ClientBookingExperience';
import ClientPaymentOptions, {
    type ClientPaymentOption
} from 'client_react/common/components/ClientPaymentOptions';

interface Props {
    paymentAmountType: ClientPaymentOption;
    setPaymentAmountType: (x: ClientPaymentOption) => void;
}

const PaymentOptions = ({ paymentAmountType, setPaymentAmountType }: Props) => {
    const t = useTranslate('booking.payment');
    const { bookingSession, bookingSessionType } = useClientBookingExperience();

    if (!bookingSession) {
        return null;
    }

    const {
        finalPaymentAmount,
        finalPaymentDueTime,
        paymentScheduleType,
        price,
        retainerPaymentAmount,
        stripeRetainerAmount
    } = bookingSession;

    if (paymentScheduleType === 'booking' || !finalPaymentDueTime) {
        return null;
    }

    const fullOptionText = t('payInFull', {
        priceTotal: price
    });

    const retainerOptionText = t(stripeRetainerAmount === 0 ? 'payLater' : 'payRetainer', {
        priceToday: retainerPaymentAmount,
        priceLater: finalPaymentAmount,
        dueDate: new Date(finalPaymentDueTime).toLocaleDateString([], {
            timeZone: bookingSessionType?.timezone ?? undefined
        })
    });

    return (
        <ClientPaymentOptions
            fullOptionText={fullOptionText}
            onChange={setPaymentAmountType}
            retainerOptionText={retainerOptionText}
            title={t('payment')}
            value={paymentAmountType}
        />
    );
};

export default PaymentOptions;
